import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
  createLesson,
  editLesson,
} from "../../../api/endpoints/LessonEndpoints";
import { LessonRequest } from "../../../models/Lesson";

export default function useCreateOrEditLesson(learningPathId: string) {
  return useMutation<
    { id: number },
    AxiosError,
    { lesson: LessonRequest; operation: "create" | "edit" }
  >({
    mutationKey: ["create-or-edit-lesson", learningPathId],
    mutationFn: ({ lesson, operation }) =>
      operation === "create"
        ? createLesson(learningPathId, lesson)
        : editLesson(lesson),
  });
}
